module.exports = __webpack_public_path__ + "media/assets/images/payments/visa-1a9661b254b4ef43d4527106a478e1da.png";